var common = require("../utiles/common")
var service = require("../utiles/service")

module.exports = {
    register: function () {
        document.createElement('record-item')
        ko.components.register('record-item', {
            viewModel: function (params) {
                var $this = this;
                $this.data = params.app;
                $this.time = params.app.dateFormat;//common.timestampToTime(params.app.eventDate);
                $this.type = common.getAuthType(params.app.authType);
                $this.userId = params.userId;
            },
            template: require("./RecordItem.html")
        });
    }
}




//////////////////
// WEBPACK FOOTER
// ./src/template/RecordItem.js
// module id = 97
// module chunks = 0